import FormattedNumber from 'I18n/components/FormattedNumber';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import { jsx as _jsx } from "react/jsx-runtime";
export const formatNumberForEnrollmentConversionReporting = origNumber => {
  if (!origNumber) return 0;else if (origNumber === 0) return 0;else if (origNumber < 100000) return /*#__PURE__*/_jsx(FormattedNumber, {
    value: origNumber
  });else if (origNumber < 1000000) return /*#__PURE__*/_jsx(FormattedNumber, {
    value: origNumber,
    abbreviate: true,
    maxFractionDigits: 1
  });else if (origNumber >= 1000000) return /*#__PURE__*/_jsx(FormattedNumber, {
    value: origNumber,
    abbreviate: true
  });else return 0;
};
export const formatPercentageForEnrollmentConversionReporting = percentage => {
  if (!percentage) return /*#__PURE__*/_jsx(FormattedPercentage, {
    value: 0
  });else if (percentage === 0) return /*#__PURE__*/_jsx(FormattedPercentage, {
    value: 0
  });else if (percentage < 1) return /*#__PURE__*/_jsx(FormattedPercentage, {
    value: percentage,
    precision: 2
  });else if (percentage < 100) return /*#__PURE__*/_jsx(FormattedPercentage, {
    value: percentage,
    precision: 1
  });else if (percentage === 100) return /*#__PURE__*/_jsx(FormattedPercentage, {
    value: percentage
  });else return /*#__PURE__*/_jsx(FormattedPercentage, {
    value: 0
  });
};